import { render, staticRenderFns } from "./DatesPicker.vue?vue&type=template&id=2a07c87e&"
import script from "./DatesPicker.vue?vue&type=script&lang=js&"
export * from "./DatesPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports